export enum StatusValue {
  NoStatus = 0,
  Success = 1,
  Failure = 2,
  Pending = 3,
}

export const SUCCESS_TIMEOUT = 400000; // ms
